import type { OmniStudioEdge, OmniStudioGraph, OmniStudioNode } from "@/lib/omnistudio/compiler/directorCompiler.types";
import type { WorldProposalGraphMaterialization } from "@/lib/world/review/worldProposalReview.types";

export function mergeWorldProposalIntoGraph(
  graph: OmniStudioGraph,
  materialized: WorldProposalGraphMaterialization,
): OmniStudioGraph {
  if (materialized.nodes.length === 0 && materialized.edges.length === 0) {
    return graph;
  }

  const nextNodes = mergeById(graph.nodes, materialized.nodes);
  const nextEdges = mergeById(graph.edges, materialized.edges);

  return {
    ...graph,
    nodes: nextNodes,
    edges: nextEdges,
    meta: {
      ...graph.meta,
      version: graph.meta.version + 1,
    },
  };
}

function mergeById<T extends { id: string }>(current: T[], incoming: T[]): T[] {
  const merged = new Map<string, T>(current.map((item) => [item.id, item] as const));

  for (const item of incoming) {
    merged.set(item.id, item);
  }

  return [...merged.values()];
}